import type { RegistryCompanySuggestion } from '../types/company';
import { formatRegistryOptionLabel } from '../hooks/useCompanyRegistrySearch';
import { __ } from '@/hub-shared/utils/i18n';

type CompanyRegistryDropdownProps = {
  open: boolean;
  results: RegistryCompanySuggestion[];
  loading: boolean;
  error: string | null;
  hasSearched: boolean;
  queryLength: number;
  onPick: (row: RegistryCompanySuggestion) => void;
};

const CompanyRegistryDropdown = ({
  open,
  results,
  loading,
  error,
  hasSearched,
  queryLength,
  onPick,
}: CompanyRegistryDropdownProps) => {
  if (!open) {
    return null;
  }

  const showEmpty =
    hasSearched && !loading && !error && queryLength >= 2 && results.length === 0;

  if (!loading && !error && results.length === 0 && !showEmpty) {
    return null;
  }

  return (
    <div className="company-registry-suggestions" role="presentation">
      {loading ? (
        <p className="company-registry-suggestions__status" aria-live="polite">
          {__('Recherche…')}
        </p>
      ) : null}
      {error ? (
        <p className="company-registry-suggestions__error" role="alert">
          {error}
        </p>
      ) : null}
      {results.length > 0 ? (
        <ul className="company-registry-suggestions__list" role="listbox">
          {results.map((row) => (
            <li key={`${row.siren}-${row.siret_siege ?? 'hq'}`}>
              <button
                type="button"
                className="company-registry-suggestions__option"
                role="option"
                onMouseDown={(e) => {
                  e.preventDefault();
                  onPick(row);
                }}
              >
                {formatRegistryOptionLabel(row)}
              </button>
            </li>
          ))}
        </ul>
      ) : null}
      {showEmpty ? (
        <p className="company-registry-suggestions__status">{__('Aucun résultat.')}</p>
      ) : null}
    </div>
  );
};

export default CompanyRegistryDropdown;
